// 2026-11-02 (pedido del dueño): un kit al que le falta alguna pieza se puede vender igual con
// la clave de administrador y una observación. Esta ventana sirve para todas las pantallas que
// venden (Ventas, Venta Rápida, Mantenimiento, Libro de caja, Venta pasada): la abre
// ventasApi cuando el servidor responde requiere_clave_kit. Solo se cierra con sus botones.
export interface FaltanteKit { kit: string; nombre: string; falta: number }

const esc = (t: string) => t.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c] as string));

export function pedirAutorizacionKit(faltantes: FaltanteKit[], aviso = ''): Promise<{ clave: string; observacion: string } | null> {
  return new Promise((resolve) => {
    const fondo = document.createElement('div');
    fondo.className = 'fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[90] p-4';
    const filas = faltantes.map((f) =>
      `<li><b>${esc(f.kit)}</b>: falta ${+Number(f.falta).toFixed(3)} × ${esc(f.nombre)}</li>`).join('');
    fondo.innerHTML = `
      <div class="bg-white rounded-lg w-full max-w-sm">
        <div class="p-4 border-b"><h3 class="font-semibold">Kit incompleto</h3></div>
        <div class="p-4 space-y-3">
          <p class="text-sm text-gray-700">En el almacén no alcanzan estas piezas:</p>
          <ul class="text-sm list-disc pl-5 space-y-1">${filas}</ul>
          <p class="text-xs text-gray-600">Se descuenta solo lo que hay. Para vender el kit igual se necesita la clave de administrador. Queda registrado en Auditoría.</p>
          ${aviso ? `<p class="text-sm text-red-600 font-medium">${esc(aviso)}</p>` : ''}
          <textarea data-k="obs" rows="2" maxlength="300" placeholder="Observación (ej.: el cliente lleva el kit sin esa pieza)"
                    class="w-full border rounded-lg px-3 py-2 text-sm"></textarea>
          <input data-k="clave" type="password" autocomplete="off" placeholder="Clave de administrador"
                 class="w-full border rounded-lg px-3 py-2 text-sm" />
          <p data-k="error" class="text-sm text-red-600 hidden"></p>
        </div>
        <div class="p-4 border-t flex gap-2 justify-end">
          <button data-k="cancelar" class="px-4 py-2 rounded-lg border">Cancelar</button>
          <button data-k="vender" class="px-4 py-2 rounded-lg bg-amber-600 text-white font-medium">Vender incompleto</button>
        </div>
      </div>`;
    document.body.appendChild(fondo);
    const el = (k: string) => fondo.querySelector(`[data-k="${k}"]`) as HTMLInputElement;
    const cerrar = (r: { clave: string; observacion: string } | null) => { fondo.remove(); resolve(r); };
    const vender = () => {
      const observacion = el('obs').value.trim(), clave = el('clave').value;
      const error = el('error');
      if (!observacion || !clave) {
        error.textContent = !observacion ? 'Escribe la observación' : 'Escribe la clave de administrador';
        error.classList.remove('hidden');
        return;
      }
      cerrar({ clave, observacion });
    };
    el('cancelar').addEventListener('click', () => cerrar(null));
    el('vender').addEventListener('click', vender);
    el('clave').addEventListener('keydown', (e) => { if ((e as KeyboardEvent).key === 'Enter') vender(); });
    el('obs').focus();
  });
}

// Tope de cantidad al vender: un kit puede pasar de sus kits armables (si le falta una pieza
// se vende con clave); un producto normal no puede pasar de su stock.
export const topeVenta = (p: any): number => (p?.es_kit ? 9999 : Number(p?.stock) || 0);
